import React from 'react';
export const createSlotsContainer = (Component) => React.forwardRef((props, ref) => {
    const { slots = {} } = props;
    return React.createElement(Component, { ...props, ...slots, ref: ref });
});
//# sourceMappingURL=createSlotsContainer.js.map